$(window).on("load",function(){
});
$(function(){

	var $body = $('body');

	// スクロールアニメーション
	$('.animate').scrolla({
		mobile: true, // モバイルの有効・無効
		once: true, // 発火は１度だけか、視界に入るたびに発火させるか
		animateCssVersion: 4 // used animate.css version (3 or 4)
	});

	//SVGスプライト
	$.ajax({
		type: 'get',
		url: '/assets/svg/icons.svg'//ここにパスを入れる（環境に合わせて変更）
	}).done(function(data) {
		var svg = $(data).find('svg');
		$('body').prepend(svg);
	});

	//ページ内スクロール
	$.smooziee();

	//スクロールしたらクラスを付与
	$(window).scroll(function () {
		if ($(this).scrollTop() > 0) {
			$body.addClass("scroll");
		} else {
			$body.removeClass("scroll");
		}
	});

	//開閉用ボタンをクリックでクラスの切替え
	$('.header_menu_btn').on('click', function () {
		$body.toggleClass('open');
		return false;
	});

	//メニュー名以外の部分をクリックで閉じる
	// $('body').on('click', function () {
	// 	$body.removeClass('open');
	// });

	$(document).on('click', function(e) {
		if(!$(e.target).is('.link_nav, .link_nav li, .link_nav li a')) {
			$body.removeClass('open');
		}
	});

	//アコーディオン
	if (window.matchMedia( "(max-width: 768px)" ).matches) {
		$(".acd_ttl").on("click", function() {
			$(this).toggleClass('open');
			$(this).next().toggleClass('open');
			$(this).next().slideToggle();
		});
	}

});